import { Type } from "@sinclair/typebox";
import { TypeBoxToType } from "@whatslly/types/TypeBoxToType";

export const URLPolicy = Type.Object({
  id: Type.String(),
  name: Type.String(),
  url: Type.String(),
  favIconUrl: Type.Optional(Type.String()),
  groupIds: Type.Array(Type.String()),
  createdAt: Type.String(),
  updatedAt: Type.Optional(Type.String()),
  watermark: Type.Optional(Type.Boolean()),
  protectDownloadPassword: Type.Optional(Type.String()),
  contentInterceptionId: Type.Optional(Type.String()),
});
export type URLPolicy = TypeBoxToType<typeof URLPolicy>;
